// Yatay urun seridini oklarla kaydirir. Her serit kendi butonlariyla eslesir.
document.querySelectorAll('[data-yv-rail]').forEach((rail) => {
  const section = rail.closest('section');
  if (!section) return;

  const step = () => rail.querySelector(':scope > *')?.offsetWidth + 18 || 320;

  section.querySelector('[data-yv-rail-prev]')?.addEventListener('click', () => {
    rail.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  section.querySelector('[data-yv-rail-next]')?.addEventListener('click', () => {
    rail.scrollBy({ left: step(), behavior: 'smooth' });
  });
});
